var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRosemountinMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 59,
    viewBox: "0 0 84 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0476 39.0952V17.084C21.0476 15.5696 22.0216 14.2269 23.4612 13.7569L57.9427 2.4976C60.2051 1.75887 62.5291 3.4448 62.5291 5.82472V47.8155C62.5291 50.1954 60.2051 51.8813 57.9427 51.1426L21.0476 39.0952ZM21.0476 39.0952H8.34921M12.582 14.545L4.94703 15.7666C3.24909 16.0382 2 17.5031 2 19.2226V27.6667V35.5952C2 37.5282 3.567 39.0952 5.5 39.0952H8.34921M8.34921 39.0952L13.9342 53.6161C14.4036 54.8368 15.5145 55.6939 16.8144 55.8383L20.4985 56.2476C23.0844 56.535 25.0687 54.0005 24.1692 51.5591L23.164 48.8307",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3809 8.61903L79.4602 4.80951M74.3809 27.2434H81.9999M74.3809 47.1376L79.4602 50.9471",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRosemountinMedia);
export default __webpack_public_path__ + "static/media/Rosemount in Media.ecac73ca3b7c5756aa26c4e8b1ee4909.svg";
export { ForwardRef as ReactComponent };